<p-table
  #dt
  [value]="data()"
  [columns]="cols()"
  [totalRecords]="totalRecords()"
  [scrollHeight]="scrollHeight()"
  [responsiveLayout]="'scroll'"
  [loading]="loading()"
  [paginator]="pagination()"
  [rows]="rowsPerPage()"
  [showFirstLastIcon]="false"
  [showPageLinks]="false"
  [globalFilterFields]="getGlobalFilterColumns()"
  stripedRows
  class="m-0"
  styleClass="p-datatable-gridlines"
>
  <ng-template pTemplate="caption">
    <div class="flex">
      <ng-content select="[tableCaptionOppositeContainer]"></ng-content>
      <p-iconfield iconPosition="left" class="ml-auto" *ngIf="searchable()">
        <p-inputicon>
          <i class="pi pi-search"></i>
        </p-inputicon>
        <input
          pInputText
          type="text"
          [formControl]="searchControl"
          [placeholder]="searchInputPlaceholder()"
        />
      </p-iconfield>
    </div>
    <ng-content select="[tableCaptionBottomContainer]"></ng-content>
  </ng-template>
  <ng-template #header let-columns>
    <tr>
      <th
        *ngFor="let column of columns"
        class="table-header"
        [style.display]="column.display ?? null"
      >
        {{ column.label }}
      </th>
    </tr>
  </ng-template>
  <ng-template #body let-rowData let-columns="columns" let-rowIndex="rowIndex">
    <tr [style.background-color]="rowIndex % 2 === 0 ? evenRowColor() : oddRowColor()">
      <td
        *ngFor="let column of columns"
        class="table-body"
        [style.display]="column.display ?? null"
      >
        @if (column.template) {
          <ng-container
            *ngTemplateOutlet="column.template; context: { rowData: rowData }"
          ></ng-container>
        } @else if (column.formatter) {
          {{ rowData[column.key] | dynamicFormatter: column.formatter }}
        } @else {
          {{ rowData[column.key] }}
        }
      </td>
    </tr>
  </ng-template>
  <ng-template #emptymessage let-columns>
    <tr>
      <td [attr.colspan]="columns.length" class="!text-center">No data to display.</td>
    </tr>
  </ng-template>
</p-table>

<!-- Custom Pagination -->
<div class="flex justify-between items-center p-5" *ngIf="pagination() && totalPages > 0">
  <span class="pagination-text">Page {{ currentPage() }} of {{ totalPages }}</span>
  <div class="flex gap-[12px]">
    <button class="global-button" (click)="previousPage()" [disabled]="isPreviewButtonDisabled()">
      Previous
    </button>
    <button class="global-button" (click)="nextPage()" [disabled]="isNextButtonDisabled()">
      Next
    </button>
  </div>
</div>
